import { supplierService } from '@/projects/platform/services/account-supplier-service';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { Button as DXButton, DataGrid, Popup } from 'devextreme-react';
import CustomStore from 'devextreme/data/custom_store';
import { t } from 'i18next';
import { useCallback, useRef, useState } from 'react'
import { ApprovalRequestTimeline } from '_metronic/partials/layout/approval-request/approval-request-history';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const RetailerList = () => {
  const dataGridRef = useRef<DataGrid>(null);
  const [approvalHistoryPopupVisible, setApprovalHistoryPopupVisible] = useState(false);
  const [currentApprovalSteps, setCurrentApprovalSteps] = useState([]);

  const store =  createCustomStore({
    key: ["retailerAccountId"],
    load: supplierService.getRetailers,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["RetailerAccountId", "=", key];
      }
    },
  });

  const onApprovalHistoryPopupHiding = useCallback(() => {
    setApprovalHistoryPopupVisible(false);
  }, [setApprovalHistoryPopupVisible]);

  return (
    <div className='view-wrapper'>
      <DataGridWrapper
        datasource={store}
        pagerVisible={true}
        filterVisible={true}
        headerFilterVisible={true}
        enableCustomToolbarContent={true}
        editingConfig={{
          mode: 'batch',
          allowAdding: false,
          allowDeleting: false,
          allowUpdating: false,
        }}
        props={{ id: 'retailer', ref: dataGridRef }}
        columns={[
          { dataField: "name", caption: t("name") },
          { dataField: "code", caption: t("code") },
          { dataField: "status", caption: t("Status"), allowFiltering: false, },
          {
            type: 'buttons',
            width: 80,
            buttons: [
              {
                name: 'save',
              },
              {
                name: 'cancel',
              },
              {
                icon: 'ordersbox',
                hint: t("request_history"),
                visible: ((e: any) => !e.row.isEditing && e.row.data.approvalSteps && e.row.data.approvalSteps.length > 0),
                onClick: (e: any) => {

                  if (e.row.data.approvalSteps && e.row.data.approvalSteps.length > 0) {
                    setCurrentApprovalSteps(e.row.data.approvalSteps)
                    setApprovalHistoryPopupVisible(true)
                  }
                }
              }
            ]
          }
        ]}
      />
      <Popup
        visible={approvalHistoryPopupVisible}
        onHiding={onApprovalHistoryPopupHiding}
        showTitle={true}
        width={600}
        height={400}
        position={{
          of: window,
          at: 'center',
          my: 'center'
        }}
        title={t("approval_history")}
      >
        <ApprovalRequestTimeline timelines={currentApprovalSteps} height='250px' />

      </Popup>
    </div>
  )
}
export default RetailerList